export default __webpack_public_path__ + "static/media/poster10.d1abec24.jpg";